import { DataSource } from '@n7-frontend/core';
import { IInnerTitleData } from '@n7-frontend/components';
export class ExportPdfDS extends DataSource {

  private lastPayload;

  protected transform(payload, option): IInnerTitleData {
    if (!payload.data || !payload.data.userData) {
      console.log(payload);
      return;
    }
    this.lastPayload = payload;
    const title = `${payload.data.userData.givenName} ${payload.data.userData.familyName}`;
    return {
      title: {
        main: {
          text: '',
        }
      },
      tools: '',
      actions: {
        buttons: [
          {
            text: option.waiting ? 'Generazione PDF in corso...' : 'Esporta PDF',
            payload: option.waiting ? null : { type: 'print', id: payload.linistryID, name: title, communication: payload.communication, auth: payload.data.auth },
            classes: 'n7-btn-print n7-btn-l' + (option.waiting ? ' n7-btn-print_waiting' : ''),
            icon: 'n7-icon-file-pdf'
          }
        ]
      }
    };
  }
  public waiting(isWaiting) {
    this.update(this.lastPayload, { waiting: isWaiting });
  }
}
